import { AppPlatform } from '@contexts/app/AppPlatform';

// TODO: appId references should be changed to appropriate context
export const getAppPlatform = (appId: string) => {
    switch (appId) {
        case 'iosAgoda':
            return AppPlatform.IOS;
        case 'androidAgoda':
            return AppPlatform.ANDROID;
        case 'reactNativeAgoda':
            return AppPlatform.ReactNative;
        default:
            return AppPlatform.WEB;
    }
};
